module.exports = __webpack_public_path__ + "static/media/natalia1.9cc78b26.jpg";